import {Component, Output, OnInit, EventEmitter, Input} from '@angular/core';

@Component({
    selector: 'app-phonenumber-contact-sales',
    templateUrl: './phonenumber-contact-sales.component.html',
    styles: [],
    standalone: false
})
export class PhonenumberContactSalesComponent implements OnInit {

  @Output()
  public selected = new EventEmitter<void>()

  constructor() { }

  ngOnInit(): void {
  }

  public onBackOverview() {
    this.selected.emit();
  }
}
